import circleCross from './circleCross'
import circleTick from './circleTick'
import bigClose from './bigClose'
import charge from './charge'
import discharge from './discharge'
import idle from './idle'
import close from './close'
import check from './check'
import applicationSubmittedForUnenrollment from '../../elements/icons/SystemUnenrollStatusIcons/applicationSubmittedForUnenrollment'
import enrolled from '../../elements/icons/SystemUnenrollStatusIcons/enrolled'
import unenrolled from '../../elements/icons/SystemUnenrollStatusIcons/unenrolled'


export default {
  circleCross,
  circleTick,
  bigClose,
  charge,
  discharge,
  idle,
  close,
  check,
  applicationSubmittedForUnenrollment,
  unenrolled,
  enrolled
}